export let data = {
  title: "Kasir",
  backBtn: "",
  actionBtn: [],
  breadcrumb: []
};
export let tabs = [
  { title: "SEMUA", filter: ""},
  { title: "BELUM DIBAYAR",filter: "Belum Dibayar", active: true },
  { title: "BELUM LUNAS",filter: "Belum Lunas" },
  { title: "LUNAS", filter: "Lunas" }
];
export let payments = [
  {
    value: "1",
    label: "Umum"
  },
  {
    value: "2",
    label: "BPJS"
  },
  {
    value: "3",
    label: "Lainnya"
  }
];
export let sorts = [
  {
    value: "desc",
    label: "Terbaru"
  },
  {
    value: "asc",
    label: "Terlama"
  }
];
export let filters = {
  colnum: "",
  columns: [
    {
      label: "dari tanggal",
      type: "date",
      placeholder: "Tanggal periksa",
      name: "created_from",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateStart"
    },
    {
      label: "sampai tanggal",
      type: "date",
      placeholder: "Tanggal periksa",
      name: "created_to",
      value: new Date(),
      mandatory: true,
      colwidth: 3,
      id: "filterDateEnd"
    },
  ]
};
export let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      placeholder: "",
      value: "desc",
      mandatory: true,
      options: sorts
    }
  ]
};
export let upperTabs = [
  {
    link: "/kasir",
    label: "Semua Tagihan",
  }, {
    link: "/kasir/ralan",
    label: "Rawat Jalan",
  },
  {
    link: "/kasir/ranap",
    label: "Rawat Inap",
    active: true
  },
  {
    link: "/kasir/ugd",
    label: "UGD"
  },
  {
    link: "/kasir/obat",
    label: "Obat / Alkes"
  },
  {
    link: "/kasir/optik",
    label: "Optik"
  },
  {
    link: "/kasir/lab",
    label: "Lab"
  },
  {
    link: "/kasir/operasi",
    label: "Operasi"
  }
];
